import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { Planner } from '@teetsh/app/src/types/planner';

export const PLANNER_KEY = 'plannerData';

export default function usePlanner() {
  const { schoolyear, school } = useSchoolSchoolyear();
  return useQuery({
    queryKey: [schoolyear.id, school.id, PLANNER_KEY],
    queryFn: () =>
      request(`/schoolyear/${schoolyear.id}/school/${school.id}/planner`, {
        method: 'GET',
      }).then<Planner>(res => res),
    refetchOnWindowFocus: false,
  });
}
